const _excluded = ["children", "innerStyle", "justifyContent", "reference", "reverse", "debug", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import Box from "../Box";
import AlignContext, { inertAlignContextProps } from "./AlignContext";
import { splitPixels } from "./AlignProps";
import AlignInfo from "./AlignInfo";
import TextAligner from "./TextAligner";
export const getAlignItemsForOrigin = origin => {
  switch (origin) {
    case 'baseline':
      return 'baseline';
    case 'top':
      return 'flex-start';
    default:
      return 'stretch';
  }
};
// Sets a reference alignment context, wraps components in a baseline aligned
// container, and establishes the reference's baseline within that container.
const AlignBox = props => {
  const {
      children,
      innerStyle = {},
      justifyContent = 'flex-start',
      reference = inertAlignContextProps,
      reverse = false,
      debug,
      style = {}
    } = props,
    remaining = _objectWithoutProperties(props, _excluded);
  const isAligned = reference !== inertAlignContextProps;
  const direction = reverse ? 'row-reverse' : 'row';
  const origin = 'baseline';
  const alignItems = isAligned ? getAlignItemsForOrigin(origin) : undefined;
  const outerStyle = {
    position: 'relative'
  };
  const value = React.useMemo(() => isAligned ? _objectSpread(_objectSpread({}, reference), {}, {
    origin,
    splitPixels
  }) : inertAlignContextProps, [isAligned, reference]);
  return (
    /*#__PURE__*/
    // @ts-expect-error - TS2322 - Type '{ origin: string; splitPixels: boolean; lineHeight: any; padding?: SpacingMap | undefined; size: any; typeface?: Typeface | undefined; weight?: FontWeight | undefined; }' is not assignable to type 'AlignContextProps'.
    React.createElement(AlignContext.Provider, {
      value: value
    }, /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
      flex: {
        alignItems,
        direction
      },
      style: _objectSpread(_objectSpread({}, outerStyle), style)
    }), debug ? /*#__PURE__*/React.createElement(AlignInfo, _extends({}, debug, {
      height: reference.lineHeight
    })) : null, /*#__PURE__*/React.createElement(TextAligner, null), /*#__PURE__*/React.createElement(Box, {
      flex: {
        direction,
        alignItems,
        justifyContent
      },
      flexBasis: "auto",
      flexGrow: 1,
      flexShrink: 1,
      style: _objectSpread(_objectSpread({}, innerStyle), {}, {
        lineHeight: 0
      })
    }, children)))
  );
};
export default AlignBox;